export const ORDER_TOUCHPOINT_LIMIT = 1000;

export const ORDER_UNKNOWN_TOUCHPOINTS_QUERY_PARAM = "unknown";
